import React from 'react'
import Products from './../components/Products/Products';

const Shop = () => {
    return (
        <div>
            <Products />
        </div>
    )
}

export default Shop
